<template>
  <component 
    ref="container"
    :is="tag" 
    :key="src"
    v-bind="bindProps"
    @click="loadFail && loadImg()"
  ><slot></slot></component>
</template>

<script>
import queryString from 'query-string';
import UrlParser from 'url-parse';

const LOADING_IMG = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScyMDBweCcgaGVpZ2h0PScyMDBweCcgdmlld0JveD0nMCAwIDEwMCAxMDAnIHByZXNlcnZlQXNwZWN0UmF0aW89J3hNaWRZTWlkJyBjbGFzcz0nbGRzLXJvbGxpbmcnIHN0eWxlPSdiYWNrZ3JvdW5kOiBub25lOyc+PGNpcmNsZSBjeD0nNTAnIGN5PSc1MCcgZmlsbD0nbm9uZScgc3Ryb2tlPScjZDJkMmNiJyBzdHJva2Utd2lkdGg9JzEwJyByPSczNScgc3Ryb2tlLWRhc2hhcnJheT0nMTY0LjkzMzYxNDMxMzQ2NDE1IDU2Ljk3Nzg3MTQzNzgyMTM4JyB0cmFuc2Zvcm09J3JvdGF0ZSgyMC45OTExIDUwIDUwKSc+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0ndHJhbnNmb3JtJyB0eXBlPSdyb3RhdGUnIGNhbGNNb2RlPSdsaW5lYXInIHZhbHVlcz0nMCA1MCA1MDszNjAgNTAgNTAnIGtleVRpbWVzPScwOzEnIGR1cj0nMC44cycgYmVnaW49JzBzJyByZXBlYXRDb3VudD0naW5kZWZpbml0ZScvPjwvY2lyY2xlPjwvc3ZnPg=="

const LOADFAIL_IMG = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGFyaWEtaGlkZGVuPSJ0cnVlIiBmb2N1c2FibGU9ImZhbHNlIiBkYXRhLXByZWZpeD0iZmFzIiBkYXRhLWljb249InRpbWVzIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtdGltZXMgZmEtdy0xMSIgcm9sZT0iaW1nIiB2aWV3Qm94PSItMTc2IC0yNDYgNzA0IDEwMjQiPjxwYXRoIGZpbGw9InJnYigyMTAsIDIxMCwgMjAzKSIgZD0iTTI0Mi43MiAyNTZsMTAwLjA3LTEwMC4wN2MxMi4yOC0xMi4yOCAxMi4yOC0zMi4xOSAwLTQ0LjQ4bC0yMi4yNC0yMi4yNGMtMTIuMjgtMTIuMjgtMzIuMTktMTIuMjgtNDQuNDggMEwxNzYgMTg5LjI4IDc1LjkzIDg5LjIxYy0xMi4yOC0xMi4yOC0zMi4xOS0xMi4yOC00NC40OCAwTDkuMjEgMTExLjQ1Yy0xMi4yOCAxMi4yOC0xMi4yOCAzMi4xOSAwIDQ0LjQ4TDEwOS4yOCAyNTYgOS4yMSAzNTYuMDdjLTEyLjI4IDEyLjI4LTEyLjI4IDMyLjE5IDAgNDQuNDhsMjIuMjQgMjIuMjRjMTIuMjggMTIuMjggMzIuMiAxMi4yOCA0NC40OCAwTDE3NiAzMjIuNzJsMTAwLjA3IDEwMC4wN2MxMi4yOCAxMi4yOCAzMi4yIDEyLjI4IDQ0LjQ4IDBsMjIuMjQtMjIuMjRjMTIuMjgtMTIuMjggMTIuMjgtMzIuMTkgMC00NC40OEwyNDIuNzIgMjU2eiIvPjwvc3ZnPg=="

export default {
  name: 'cx-img',
  props: {
    DEFAULT_IMG: {
      type: String,
      default: LOADING_IMG,
    },
    LOADING_IMG: {
      type: String,
      default: LOADING_IMG
    },
    tag: {
      type: String,
      default: "img"
    },
    src: {
      type: String,
      default: ""
    },
    srcSet: {
      type: String,
      default: ""
    },
    lazyLoad: {
      type: Boolean,
      default: false,
    },
    lazyLoadMargin: {
      type: Number,
      default: 100,
    },
    lazyLoadThreshold: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isMounted: false,
      observer: null,
      observed: false,
      loaded: false,
      loadFail: false
    }
  },
  computed: {
    success: function() {
      return !this.loadFail
    },
    isImg: function() {
      return this.tag == 'img';
    },
    bindProps: function() {
      const props = {};

      let imgSrc = LOADFAIL_IMG;
      
      if (!this.loadFail) {
        imgSrc = (((this.lazyLoad && this.observed) || !this.lazyLoad) 
        && this.loaded) ? this.src : this.DEFAULT_IMG
      }

      if (this.isImg) {
        props.src = imgSrc
      } else {
        props.style = {
          'backgroundImage': `url(${this.isMounted ? imgSrc : this.DEFAULT_IMG})`
        }
      }

      console.log('[cxImg]', props);
      return props;
    }
  },
  watch: {
    observed: {
      immediate: true,
      handler: function() {
        if (this.lazyLoad && this.observed) {
          this.loadImg();
        }
      }
    }
  },
  methods: {
    loadImg: function() {
      console.log('[cxImg] LOAD IMG', this.src)
      this.loaded = false;
      this.loadFail = false;

      const img = new Image();
      const vm = this;

      img.onload = () => {
        console.log('[cxImg] loaded', this.src);
        this.loaded = true;
        this.$emit('load', true);
      }

      img.onerror = () => {
        console.log('[cxImg] fail to load', this.src);
        this.loaded = true;
        this.loadFail = true;
        this.$emit('load', false);
      }

      img.src = this.src;
    },
    initObserver: function() {
      if (this.$refs 
        && this.$refs.container 
        && "IntersectionObserver" in window
      ) {
        this.observer = new IntersectionObserver((entries, observer) => {
          let {isIntersecting, intersectionRatio} = entries[0];
          if (isIntersecting) {
            this.observed = true;
            this.observer.unobserve(this.$refs.container);
          }
        }, {
          root: null,
          rootMargin: `${this.lazyLoadMargin}px`,
          threshold: this.lazyLoadThreshold
        });
        this.observer.observe(this.$refs.container);
      } else {
        this.observed = true;
      }
    },
    removeObserver: function() {
      this.observer && this.observer.unobserve(this.$refs.container);
    }
  },
  created() {  },
  mounted() {
    this.isMounted = true;
    if (this.lazyLoad) {
      this.initObserver();
    } else {
      this.loadImg();
    }
  },
  beforeDestroy() {
    this.lazyLoad && this.removeObserver();
  },
}
</script>
